import log from 'salvo-lite/log'
import AjaxCart from '../helpers/AjaxCart'
import Swiper, { Pagination, A11y, Thumbs } from 'swiper'

class Product {
    constructor (theme) {
        this._theme = theme
        this._addToCart = document.querySelectorAll('[data-add-to-cart]')
        this._popup = document.querySelector('.product__add-on')
        this._tattoo = document.querySelector('[name="properties[tattoo]"]')
        this._mainSlider = document.querySelector('[data-main-slider]')
        this._thumbSlider = document.querySelector('[data-thumbnail-slider]')
        this._addOnSlider = document.querySelector('[data-add-on-slider]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    async onInit () {
        this._sliders()
        if (this._addToCart) {
            this._addToCart.forEach(add => {
                add.addEventListener('click', e => {
                    e.preventDefault()
                    this._add(e, add)
                })
            })
        }
    }
    async _add (e, add) {
        const info = JSON.parse(add.getAttribute('data-add-to-cart'))
        const quantity = 1
        const selectedVariant = info.id
        const originalText = add.textContent
        add.textContent = info.adding
        let payload = ''
        if (this._tattoo && this._tattoo.checked) {
            payload = {quantity, id: selectedVariant, properties: {tattoo: this._tattoo.checked}}
        } else {
            payload = {quantity, id: selectedVariant}
        }
        const data = await AjaxCart.addItem(payload)
        if (this._tattoo && this._tattoo.checked) {
            let tattoo = false
            data.cart.data.items.forEach(item => {
                if (item.properties.tattoo) {
                    let sku = item.sku ? item.sku : item.id
                    if (!tattoo) {
                        tattoo = sku
                    } else {
                        tattoo += `, ${sku}`
                    }
                }
            })
            const cartPayload = {attributes: {tattoo: tattoo}}
            await AjaxCart.updateCart(cartPayload)
        }
        add.textContent = info.added
        setTimeout(() => {
            add.textContent = originalText
            if (this._popup) {
                this._popup.classList.remove('visually-hidden')
                document.body.classList.add('no-scroll')
            }
        }, 3000)
    }
    _sliders () {
        Swiper.use([Pagination, A11y, Thumbs])
        const thumbnails = new Swiper(this._thumbSlider, {
            // loop: true,
            slidesPerView: 7,
            spaceBetween: 10,
            watchSlidesProgress: true
            // centeredSlides: true
        })
        const mainSlider = new Swiper(this._mainSlider, {
            // loop: true,
            watchSlidesProgress: true,
            pagination: {
                el: '.swiper-pagination'
            },
            thumbs: {
                swiper: thumbnails
            },
            preventClicks: true,
            preventClicksPropagation: true
        })
        mainSlider.on('slideChange', function () {
            document.querySelectorAll('.product__media-slider video').forEach(video => {
                if (!video.paused) {
                    const evt = new Event('pauseVideo')
                    video.dispatchEvent(evt)
                    console.log('here', video)
                }
            })
        })
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js